import React, { useState, useEffect, useContext } from 'react';
import axios from 'axios';
import { AuthContext } from '../contexts/AuthContext';
import { Navigate } from 'react-router-dom';
import './ImageHost.css';

const ImageHost = () => {
  const [images, setImages] = useState([]);
  const [selectedFile, setSelectedFile] = useState(null);
  const [imageName, setImageName] = useState('');
  const { user, loading } = useContext(AuthContext);

  const fetchImages = async () => {
    try {
      const res = await axios.get('/images');
      setImages(res.data);
    } catch (err) {
      console.error('获取图片失败:', err);
    }
  };

  useEffect(() => {
    if (user) {
      fetchImages();
    }
  }, [user]);

  if (loading) return <div className="loading">加载中...</div>;
  if (!user) return <Navigate to="/account" />;
  if (!(user.permission === '腐竹' || user.permission === '管理')) return <div className="no-access">需要管理员权限</div>;

  const handleUpload = async (e) => {
    e.preventDefault();
    try {
      const data = new FormData();
      data.append('name', imageName);
      data.append('image', selectedFile);

      await axios.post('/images', data, {
        headers: { 'Content-Type': 'multipart/form-data' }
      });

      setSelectedFile(null);
      setImageName('');
      fetchImages();
    } catch (err) {
      console.error('上传失败:', err);
    }
  };

  const handleDelete = async (id) => {
    if (window.confirm('确定要删除这张图片吗？')) {
      try {
        await axios.delete(`/images/${id}`);
        fetchImages();
      } catch (err) {
        console.error('删除失败:', err);
      }
    }
  };

  const copyUrl = (url) => {
    const fullUrl = `https://longtengrailway.top${url}`;
    navigator.clipboard.writeText(fullUrl);
    alert('图片链接已复制！');
  };

  return (
    <div className="image-host">
      <h1>图床</h1>
      
      <form onSubmit={handleUpload} className="upload-form">
        <input
          type="text"
          placeholder="图片名称"
          value={imageName}
          onChange={(e) => setImageName(e.target.value)}
          required
        />
        <input
          type="file"
          accept="image/*"
          onChange={(e) => setSelectedFile(e.target.files[0])}
          required
        />
        <button type="submit" className="btn-primary">上传</button>
      </form>

      <div className="images-grid">
        {images.map((image) => (
          <div key={image._id} className="image-card">
            <img src={`https://longtengrailway.top${image.url}`} alt={image.name} />
            <div className="image-info">
              <h4>{image.name}</h4>
              <div className="image-actions">
                <button onClick={() => copyUrl(image.url)} className="btn-copy">复制链接</button>
                <button onClick={() => handleDelete(image._id)} className="btn-delete">删除</button>
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default ImageHost;
